import React, {FC, useState} from 'react'
import {TaskTemplateData} from '@dv5/domain'
import {Input} from '../inputs/Input'
import {MultilineEditor} from '../inputs/MultilineEditor'
import {MarkdownViewer} from '../markdown/MarkdownViewer'
import './TaskTemplateEditor.less'

interface Props {
    data: TaskTemplateData
    onChange: (data: TaskTemplateData) => void
    onConfirm: () => void
    onCancel: () => void
}

export const TaskTemplateEditor: FC<Props> = ({data, onChange, onConfirm, onCancel}) => {
    const [descMode, setDescMode] = useState<'edit' | 'preview'>('edit')

    const changeTitle = (title: string) => {
        onChange({...data, title})
    }
    const changeDescription = (description: string) => {
        onChange({...data, description})
    }
    const changeWebHookUrl = (webHookUrl: string) => {
        onChange({...data, webHookUrl})
    }

    return (
        <div className="task-template-editor">
            <Input id={'taskTemplateTitle'}
                   value={data.title}
                   setValue={changeTitle}
                   label={'Title'}
                   placeholder={'Task title'}
                   onConfirm={onConfirm}
                   onCancel={onCancel}
            />
            <label className="task-template-editor__label">Description</label>
            <div className="task-template-editor__desc-tabs">
                <button className={`desc-tab ${descMode === 'edit' ? 'active' : ''}`}
                        onClick={() => setDescMode('edit')}>Edit</button>
                <button className={`desc-tab ${descMode === 'preview' ? 'active' : ''}`}
                        onClick={() => setDescMode('preview')}>Preview</button>
            </div>
            {descMode === 'edit' ? (
                <MultilineEditor
                    value={data.description}
                    setValue={changeDescription}
                    onConfirm={onConfirm}
                    onCancel={onCancel}
                    settings={{autoResize: true}}
                    disabled={false}
                />
            ) : (
                <MarkdownViewer
                    sourceCode={data.description}
                    compactMode={false}
                    onToggleCheckBox={() => {}}
                />
            )}
            <Input id={'taskTemplateWebHookUrl'}
                   value={data.webHookUrl}
                   setValue={changeWebHookUrl}
                   label={'Webhook URL'}
                   placeholder={'https://hooks.example.com/...'}
                   onConfirm={onConfirm}
                   onCancel={onCancel}
            />
        </div>
    )
}
